
    var riot = require('riot')
    
import _ from 'lodash'
import moment from 'moment'
riot.tag2('saijiki-calendar-table', '<div class="c-saijiki-calendar__table"> <div class="show-pc"> <table> <colgroup> <col width="40%"> <col width="40%"> <col width="5%"> <col width="5%"> <col width="5%"> <col width="5%"> <col width="5%"> <col width="5%"> <col width="5%"> <col width="5%"> </colgroup> <thead> <tr> <th>場所</th> <th>状況</th> <th each="{i, key in stateNames()}"> <div class="is-oneline">{i.name}</div> </th> </tr> </thead> <tbody if="{opts.state.sakuras}"> <tr key="{key}" each="{tr, key in opts.state.sakuras}"> <td> <div class="spot-link"><a href="/spot/detail/{tr.Spot.id}">{tr.Spot.name}</a></div> <address if="{tr.Spot.ha_check}"><span>{tr.Spot.ha_name}</span><span>{tr.Spot.ha_tel}</span><span>{getCityName(tr.Spot.Place.city)}{tr.Spot.Place.addr}</span></address> <address if="{!tr.Spot.ha_check}"><span>{tr.Spot.User.name}</span><span>{tr.Spot.User.tel}</span><span>{getCityName(tr.Spot.Place.city)}{tr.Spot.Place.addr}</span></address> </td> <td> <div class="state-img" riot-style="{setIcon(tr.Sakura.pos)};"></div> <div class="state-name">{getStateName(tr.Sakura.pos)}</div> <div class="state-content">{tr.Sakura.detail}</div> <div class="state-content">{updatedText(tr.Sakura.modified)}</div> </td> <td class="is-center">{tr.Sakura.dt1}</td> <td class="is-center">{tr.Sakura.dt2}</td> <td class="is-center">{tr.Sakura.dt3}</td> <td class="is-center">{tr.Sakura.dt4}</td> <td class="is-center">{tr.Sakura.dt5}</td> <td class="is-center">{tr.Sakura.dt6}</td> <td class="is-center">{tr.Sakura.dt7}</td> <td class="is-center">{tr.Sakura.dt8}</td> </tr> </tbody> </table> </div> <div class="show-sp"> <table> <colgroup> <col width="50%"> <col width="50%"> </colgroup> <thead> <tr> <th>場所</th> <th>状況</th> </tr> </thead> <tbody> <tr key="{key}" each="{tr, key in opts.state.sakuras}"> <td> <div class="spot-link"><a href="/spot/detail/{tr.Spot.id}">{tr.Spot.name}</a></div> <address if="{tr.Spot.ha_check}"><span>{tr.Spot.ha_name}</span><span>{tr.Spot.ha_tel}</span><span>{getCityName(tr.Spot.Place.city)}{tr.Spot.Place.addr}</span></address> <address if="{!tr.Spot.ha_check}"><span>{tr.Spot.User.name}</span><span>{tr.Spot.User.tel}</span><span>{getCityName(tr.Spot.Place.city)}{tr.Spot.Place.addr}</span></address> </td> <td> <div class="state-img" riot-style="{setIcon(tr.Sakura.pos)};"></div> <div class="state-name">{getStateName(tr.Sakura.pos)}</div> <div class="state-content">{tr.Sakura.detail}</div> <div class="state-content">{updatedText(tr.Sakura.modified)}</div> </td> </tr> </tbody> </table> </div> </div>', '', '', function(opts) {
    const self = this
    self.kind  = self.opts.state.kind

    self.areaNames = () => {
      let areas = _.map(self.opts.state.areas, (i, id) => {
        let name = i.split('エリア')[0]
        return { id, name }
      })
      return areas
    }

    self.updatedText = (datetime) => {
      return moment(datetime).format('M/D 更新')
    }

    self.getCityName = (id) => {
      try {
        if ( self.opts.state.cities[id] ) {
          return self.opts.state.cities[id]
        } else {
          return null
        }
      } catch(err) {
        return null
      }
    }

    self.stateNames = () => {
      let names = _.map(self.opts.state.treeStates, (i, id) => {
        let obj = self.opts.state.treeStates[id]
        return obj
      })
      return names
    }

    self.getStateName = (id) => {
      try {
        let obj = self.opts.state.treeStates[id]
        if ( obj ) {
          return obj.name
        }
      } catch(error) {
        returnnull
      }
    }

    self.setIcon = (key) => {
      return `background-image: url('/design/img/hanasaijiki/icons/${self.kind}-${key}.png')`
    }
});
    
  


// WEBPACK FOOTER //
// ./_src/js/riot/saijiki-calendar/saijiki-calendar-table.tag